import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchDateVisitsAll = async (
  site_id: any,
  startDate: any,
  endDate: any
) => {
  const result = await fetch(
    `${REACT_APP_VMS_BASE_URL}/visits/sites/${site_id}/all?start=${startDate}&end=${endDate}`
  );
  const visits = await result.json();
  return visits;
};

export default fetchDateVisitsAll;
